"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgArrowLeftFilled = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 18.842c0 1.03-1.224 1.545-1.94.817l-6.727-6.842a1.17 1.17 0 0 1 0-1.634L14.06 4.34c.716-.728 1.94-.213 1.94.817v13.684Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgArrowLeftFilled);
//# sourceMappingURL=SvgArrowLeftFilled.js.map